const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const ColorSwatch = require('components/charts/ColorSwatch/ColorSwatch');
const DataTable = require('components/charts/DataTable/DataTable');
const DataTableColumn = require('components/charts/DataTableColumn/DataTableColumn');
const rotateColor = require('utilities/rotateColor');
const assetAllocationType = require('utilities/assetAllocationType');
const { formatValue } = require('../utilities/valueFormater');

const formatValuePercentage = v => `${formatValue(v)}%`;

const AssetAllocationsTable = ({ colors, data, onMouseEnterRow }) => (
    <DataTable
        data={data}
        onMouseEnterRow={i => onMouseEnterRow && onMouseEnterRow(i)}
        returnIndex
    >
        <DataTableColumn
            format={(_, i) => <ColorSwatch color={rotateColor(colors, i)} />}
        />
        <DataTableColumn dataKey="type" format={assetAllocationType} />
        <DataTableColumn
            dataKey="long"
            format={formatValuePercentage}
            header={formatText('fundsCard-long').toUpperCase()}
        />
        <DataTableColumn
            dataKey="short"
            format={formatValuePercentage}
            header={formatText('fundsCard-short').toUpperCase()}
        />
        <DataTableColumn
            dataKey="net"
            format={formatValuePercentage}
            header={formatText('fundsCard-net').toUpperCase()}
        />
        <DataTableColumn
            dataKey="cat"
            format={formatValuePercentage}
            header={formatText('fundsCard-category').toUpperCase()}
        />
    </DataTable>
);

AssetAllocationsTable.propTypes = {
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    onMouseEnterRow: PropTypes.func,
};

module.exports = AssetAllocationsTable;
